import { render, staticRenderFns } from "./DangerDeleteModal.vue?vue&type=template&id=93bb5252&scoped=true&"
import script from "./DangerDeleteModal.vue?vue&type=script&lang=js&"
export * from "./DangerDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./DangerDeleteModal.vue?vue&type=style&index=0&id=93bb5252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bb5252",
  null
  
)

export default component.exports